module.exports = __webpack_public_path__ + "img/save10.686b551d.png";